import { SentimentWordConfig } from './types';

export const deSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        'aktiv',
        'bereit',
        'besser',
        'brillant',
        'erfolg',
        'erfolgreich',
        'fertig',
        'froh',
        'gesund',
        'glucklich',
        'gut',
        'hilfreich',
        'klar',
        'komplett',
        'nutzlich',
        'optimistisch',
        'perfekt',
        'positiv',
        'profit',
        'ruhig',
        'sicher',
        'stabil',
        'stark',
        'super',
        'toll',
        'unterstutzt',
        'verbessert',
        'verbesserung',
        'wachstum',
        'wunderbar',
        'sieg',
        'gelost',
        'anerkannt',
        'ausgezeichnet',
        'begeistert',
        'beliebt',
        'entspannt',
        'erreicht',
        'freude',
        'freundlich',
        'gewonnen',
        'gluck',
        'hoffnung',
        'inspiration',
        'kind',
        'leicht',
        'liebe',
        'motivation',
        'nutzen',
        'ordnung',
        'reif',
        'rettung',
        'stolz',
        'unterstutzung',
        'verbessern',
        'vollendet',
        'voran',
        'wertvoll',
        'wirksam',
        'zuversicht',
        'aufatmen',
        'aufgeraumt',
        'aufmunternd',
        'ausdauernd',
        'ausgeglichen',
        'belebend',
        'beflugelt',
        'befreit',
        'behaglich',
        'bequem',
        'beruhigend',
        'beruhigt',
        'brauchbar',
        'ehrlich',
        'einfach',
        'einladend',
        'empfohlen',
        'ermutigend',
        'erneuert',
        'festlich',
        'freundschaft',
        'gedeihen',
        'gelingen',
        'gemutlich',
        'gerecht',
        'gewiss',
        'glanz',
        'harmonie',
        'heiter',
        'komfort',
        'liebenswert',
        'locker',
        'munter',
        'ordentlich',
        'prima',
        'sanft',
        'tatkraft',
        'trost',
        'verlasslich',
        'wohlgefuhl',
    ]),
    negativeWords: new Set([
        'abgelehnt',
        'absturz',
        'angst',
        'besorgt',
        'blockiert',
        'chaos',
        'defekt',
        'dringend',
        'fehler',
        'frustriert',
        'gefahr',
        'gefahrlich',
        'hart',
        'hass',
        'kaputt',
        'langsam',
        'negativ',
        'problem',
        'regression',
        'risiko',
        'schlecht',
        'schmerz',
        'schwach',
        'sorge',
        'spat',
        'tot',
        'traurig',
        'unsicher',
        'verzogert',
        'verspatet',
        'schlimm',
        'alarm',
        'anstrengend',
        'arger',
        'argerlich',
        'bedrohung',
        'beklemmend',
        'belastung',
        'deprimiert',
        'drama',
        'durcheinander',
        'elend',
        'ernst',
        'falsch',
        'frust',
        'geblockt',
        'heikel',
        'hindernis',
        'kollaps',
        'kompliziert',
        'konflikt',
        'kritisch',
        'lahm',
        'mangel',
        'misslungen',
        'nervig',
        'notfall',
        'panik',
        'ruckgang',
        'schaden',
        'schrecklich',
        'stillstand',
        'stress',
        'unschon',
        'verlust',
        'verwirrt',
        'warnung',
        'albtraum',
        'alarmierend',
        'anstrengung',
        'beschadigt',
        'bitter',
        'chaotisch',
        'druck',
        'duster',
        'eklig',
        'furchtbar',
        'gefahrdet',
        'gehemmt',
        'genervt',
        'gestort',
        'grausam',
        'hasslich',
        'instabilitat',
        'krampfhaft',
        'mude',
        'niederlage',
        'not',
        'peinlich',
        'qual',
        'rot',
        'schwierig',
        'sorgenvoll',
        'toxisch',
        'trauma',
        'ubel',
        'verletzlich',
        'verloren',
        'verzweifelt',
        'wut',
    ]),
};
